import { PageModule, PageModuleType } from '@/types/module.types';
import { PageLinkType } from '@/types/homepage.types';
import { BrandliveEvent } from '@/types/projects.types';
import { GetDefaultCallToAction } from '@/utils/registration/registration';
import { saveWorkingProject, setRegistrationOn, updateHomepageModule } from '@/store/slices/project';
import { useAppDispatch } from '@/store/hooks';

// Previously named "registrationToggled"
export const checkRegistrationToggled = (
  isOn: boolean,
  workingProject: BrandliveEvent,
  dispatch: ReturnType<typeof useAppDispatch>
): void => {
  // update landing page callToAction buttons (header and callout module) when turning registration on/off
  // only if pointing to registration or home page
  const headerLink = workingProject?.homepage?.header.callToAction.content.page;
  const calloutModule = workingProject?.homepage?.modules.find(
    (module: PageModule) => module.type === PageModuleType.callout
  );
  const calloutLink = calloutModule?.content.callToAction.content.page;

  const newCallToAction = GetDefaultCallToAction(isOn);
  const updateHeaderCallToAction =
    headerLink === PageLinkType.homepage || headerLink === PageLinkType.registration ? newCallToAction : null;
  const updateCalloutCallToAction =
    calloutLink === PageLinkType.homepage || calloutLink === PageLinkType.registration ? newCallToAction : null;

  if (updateHeaderCallToAction && workingProject?.homepage?.header) {
    const updatedProject: BrandliveEvent = {
      ...workingProject,
      homepage: {
        ...workingProject.homepage,
        header: {
          ...workingProject.homepage?.header,
          callToAction: updateHeaderCallToAction,
        },
      },
    };
    dispatch(saveWorkingProject({ project: updatedProject }));
  }

  if (calloutModule && updateCalloutCallToAction) {
    dispatch(
      updateHomepageModule({
        module: {
          ...calloutModule,
          content: {
            ...calloutModule.content,
            callToAction: updateCalloutCallToAction,
          },
        },
      })
    );
  }
  dispatch(setRegistrationOn(isOn));

  return;
};
